import { HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { HttpErrorResponse } from "@angular/common/http";
import { catchError, throwError } from "rxjs";
import { AccountService } from "../services/account.service";

export const authInterceptor: HttpInterceptorFn = (req, next) => {
    const accountService = inject(AccountService);

    return next(req).pipe(
        catchError((error: HttpErrorResponse) => {
            if (error.status >= 400 && error.status < 500) {
                accountService.logout();
            }
            return throwError(() => error);
        }),
    );
};
